// extracted by mini-css-extract-plugin
export default {"notfound":"PageNotFound_notfound__zHwxB","text":"PageNotFound_text__-XAT4"};